import { render, staticRenderFns } from "./packageSeriesManage.vue?vue&type=template&id=5b7e32c6&scoped=true&"
import script from "./packageSeriesManage.vue?vue&type=script&lang=js&"
export * from "./packageSeriesManage.vue?vue&type=script&lang=js&"
import style0 from "./packageSeriesManage.vue?vue&type=style&index=0&id=5b7e32c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e32c6",
  null
  
)

export default component.exports